export default __webpack_public_path__ + "static/media/information_project.f546878c.png";